import Link from 'next/link'
import { FontAwesomeSvgIcon } from 'react-fontawesome-svg-icon'

import { faChartPieSimple } from '@fortawesome/pro-light-svg-icons'
import clsx from 'clsx'

import { trackClickForSegmentAnalytics } from '@infura/packages.common/segmentAnalytics'
import { Card } from '@infura/packages.ui/Card'
import { Heading } from '@infura/packages.ui/Heading'
import { Text } from '@infura/packages.ui/Text'
import { ServiceTier } from '@infura/packages.uks'

import { CreditThroughput } from 'components/dashboard/analytics-overview/CreditThroughput/CreditThroughput'
import { DailyRequestHealthChart } from 'components/dashboard/analytics-overview/DailyRequestHealthChart/DailyRequestHealthChart'
import { UsageSection } from 'components/dashboard/analytics-overview/UsageSection'

import { useUKSServicePlan } from 'hooks/useUKSServicePlan'

import { STATS_ROUTE } from 'lib/constants'
import { getOnCreditPlan } from 'lib/utils/creditPlan'

export const AnalyticsOverview = () => {
  const { servicePlan } = useUKSServicePlan()

  const isCoreUser = servicePlan?.tier === ServiceTier.CORE
  const isOnCreditPlan = getOnCreditPlan(servicePlan)

  const hideCreditThroughput = isCoreUser || !isOnCreditPlan

  return (
    <div className='mb-6'>
      <Heading theme='page'>Analytics Overview</Heading>
      <div
        className={clsx('mt-4 gap-6 space-y-6 md:grid md:space-y-0', {
          'md:grid-cols-3': hideCreditThroughput,
          'md:max-3xl:grid-cols-2 3xl:grid-cols-4': !hideCreditThroughput
        })}
      >
        <Card>
          <div className='flex items-center justify-between'>
            <div className='flex items-center gap-2'>
              <FontAwesomeSvgIcon className='text-text-default' icon={faChartPieSimple} size='sm' />
              <Text className='font-bold'>Daily Request Health</Text>
            </div>
            <Link
              data-testid='daily-request-health-view-stats'
              href={STATS_ROUTE}
              onClick={() => {
                trackClickForSegmentAnalytics({
                  clickText: 'View Stats',
                  location: 'Analytics Overview Daily Request Health',
                  type: 'Text'
                })
              }}
            >
              View Stats
            </Link>
          </div>
          <DailyRequestHealthChart />
        </Card>
        {!hideCreditThroughput ? <CreditThroughput /> : null}
        <UsageSection />
      </div>
    </div>
  )
}
